import { localisedValue } from "utils"

const ClassificationTransformer = response => {
  return response.map(e => ({
    ...e,
    key: e.id,
    label: localisedValue({ object: e, key: "name" }),
    value: e.id.toString(),
    id: e.id,
    slug: e?.key,
  }))
}

export default ClassificationTransformer
